import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/** xhr bridge if we ever gonna need to change Axios for something different */
export async function xhr<T>(options: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return axios(options);
}
